export default {
      id: "i-advantage4-usage",
      viewBox: "0 0 50 30",
      url: __webpack_public_path__ + "img/sprite.svg#i-advantage4",
      toString: function () {
        return this.url;
      }
    }